import { VALIDATION_MESSAGES } from '../core/ValidationMessages';
export function validateRequired(value, fieldName) {
    if (!value || value.trim() === '') {
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.FIELD_REQUIRED(fieldName)],
        };
    }
    return { isValid: true, errors: [] };
}
export function validateInOptions(value, options, fieldName) {
    if (options.length === 0) {
        return {
            isValid: false,
            errors: [`${fieldName} has no valid options`],
        };
    }
    if (!options.includes(value)) {
        const optionsAsStrings = options.map(String);
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.VALUE_NOT_IN_OPTIONS(fieldName, optionsAsStrings)],
        };
    }
    return { isValid: true, errors: [] };
}
